import LabeledTooltip from './labeled-tooltip.js';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';
import { noop } from 'mojito/utils';

const UIView = MojitoCore.Presentation.UIView;
/**
 * Labeled tooltip component. Renders an icon with a text label. Clicking on in, a popup with additional content appears.
 *
 * @function LabeledTooltip
 * @memberof Mojito.Presentation.Components
 */

/**
 * LabeledTooltip prop types.
 *
 * @property {string} [title] - Text label appears next to an icon.
 * @property {string} [additionalInfo] - Additional text label.
 * @property {string} [tooltipText] - Text for tooltip content.
 * @property {string} [tooltipButtonText] - Tooltip content button text.
 * @property {Function} [onTooltipButtonClick = () => {}] - Callback for tooltip button click.
 * @property {boolean} [showTooltipButton] - Indicates whether tooltip button should be rendered.
 * @property {boolean} [disabled = false] - Flag indicating whether the component is clickable and can present the tooltip popover.
 * @memberof Mojito.Presentation.Components.LabeledTooltip
 */
const propTypes = {
    title: PropTypes.string,
    additionalInfo: PropTypes.string,
    tooltipText: PropTypes.string,
    tooltipButtonText: PropTypes.string,
    onTooltipButtonClick: PropTypes.func,
    showTooltipButton: PropTypes.bool,
    disabled: PropTypes.bool,
};

const defaultProps = {
    onTooltipButtonClick: noop,
    disabled: false,
};

export default UIView('LabeledTooltip', LabeledTooltip, propTypes, defaultProps);
